import { useEffect, useState } from "react";
import { useGameContext } from "../Hook/GameContext";
import {
  GameReBuyInRange,
  GameReBuyInButtonWrapper,
  GameReBuyInPopupWrapper,
  GameReBuyInResult,
  GameReBuyInScrollWrapper,
  GameReBuyInValues,
  GameReBuyInValuesWrapper,
  GameReBuyInRangeValue,
} from "../Style/GameReBuyInPopupStyles";
import { getTournamentType } from "../../../../utils/common";
import { TournamentInfoInterface } from "../../../../api/game";
import { enqueueSnackbar } from "notistack";

interface ReBuyInDialogProps {
  moveToRingGameListPage: () => void;
}

const ReBuyInDialog = ({ moveToRingGameListPage }: ReBuyInDialogProps) => {
  const {
    groupId,
    userTicketInfo,
    playGame,
    tournamentData,
    setIsReBuyInPopupOpen,
  } = useGameContext();
  const min = 40000;
  const max = 500000;
  const [amount, setAmount] = useState(40000);
  const [userGp, setUserGp] = useState(0);
  const [trachWidth, setTrachWidth] = useState(1.84615);
  const [tournamentInfo, setTournamentIno] =
    useState<TournamentInfoInterface>();

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (userGp < +e.target.value) return;
    setAmount(Number(e.target.value));
  };

  useEffect(() => {
    const tournament = tournamentData.find(
      (item) => item.info.groupId === groupId
    );
    setTournamentIno(tournament);
  }, [tournamentData]);

  useEffect(() => {
    let width = ((amount - min) / (max - min)) * 100;
    if (amount >= 150000) {
      width -= 3;
    } else {
      width += 3;
    }
    setTrachWidth(width);
  }, [amount, min, max]);

  useEffect(() => {
    if (!userTicketInfo) return;
    setUserGp(userTicketInfo?.user.point);
  }, [userTicketInfo]);

  const handlePlayGame = () => {
    if (!tournamentInfo) return;
    if (userGp - amount < 0) {
      enqueueSnackbar("보유하신 GP가 부족합니다. ", { variant: "error" });
      return;
    }
    playGame({
      groupId,
      useRebuyinTicket: false,
      addedGameMoney: amount,
      type: getTournamentType(tournamentInfo.info.data.startedAt),
    });
  };

  return (
    <GameReBuyInPopupWrapper>
      <div className="content">
        <div className="wrapper">
          <div className="header">리바인</div>
          <GameReBuyInValuesWrapper>
            <div className="header">리바인 금액</div>
            <GameReBuyInValues>
              <GameReBuyInRangeValue>
                <div className="name">MIN</div>
                <div className="value">{min.toLocaleString()}</div>
              </GameReBuyInRangeValue>
              <div className="result-value">{amount.toLocaleString()}</div>
              <GameReBuyInRangeValue>
                <div className="name">MAX</div>
                <div className="value">{max.toLocaleString()}</div>
              </GameReBuyInRangeValue>
            </GameReBuyInValues>
          </GameReBuyInValuesWrapper>
          <GameReBuyInScrollWrapper>
            <GameReBuyInRange>
              <div
                className="track"
                style={{
                  width: `${trachWidth}%`,
                }}
              />
              <input
                type="range"
                min={min}
                max={max}
                step={10000}
                value={amount}
                onChange={handleSliderChange}
              />
            </GameReBuyInRange>
          </GameReBuyInScrollWrapper>
          <GameReBuyInResult>
            <div className="text">리바인 후 남은 금액</div>
            <div className="value">{(userGp - amount).toLocaleString()}</div>
          </GameReBuyInResult>
          <GameReBuyInButtonWrapper>
            <div
              className="button"
              onClick={() => {
                setIsReBuyInPopupOpen(false);
                moveToRingGameListPage();
              }}
            >
              취소
            </div>
            <div
              className="button purple"
              onClick={() => {
                handlePlayGame();
              }}
            >
              리바인
            </div>
          </GameReBuyInButtonWrapper>
        </div>
      </div>
    </GameReBuyInPopupWrapper>
  );
};

export default ReBuyInDialog;
